import * as React from 'react';
import { useContext } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';


import axios from 'axios';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material//MenuItem';
import { UserContext } from '../context/UserContext';
// import { createTheme} from '@mui/material/styles';





export default function CreateMarkets(props) {

  const userData = useContext(UserContext);
  const storedHeaders = sessionStorage.getItem('headers');
  const headers = storedHeaders ? JSON.parse(storedHeaders) : {};

  const title = "Create A Shelf";
  //&Account DropDown
  //&Account DropDown
  //&Account DropDown
  //! Data and Select for Account Dropdown
  const [selectedAccount, setSelectedAccount] = React.useState(userData.accountCode);
  //! accountList comes from Dashboard
  const handleAccountSelect = (event) => {
    setSelectedAccount(event.target.value);
    props.getWarehouseList(event.target.value);
  };

  const [selectedWarehouse, setSelectedWarehouse] = React.useState('');
  //! regionList comes from Dashboard
  const handleWarehouseSelect = (event) => {
    setSelectedWarehouse(event.target.value);
  };



   //SECTION Form Validation
    //! Form Validation
    const [ buttonDisable, setButtonDisable ] = React.useState(true);


    const [ validFields, setValidFields ] = React.useState(
      {
        "shelfName": false,

     });

    const [ helperText, setHelperText ] = React.useState(
      {
        "shelfName":"Shelf Name"
    
       });


    const [ validShelfName, setValidShelfName ] = React.useState(false);
    // const [ validCountryName, setValidCountryName ] = React.useState(false);

    React.useEffect(() => {
        if (validShelfName) {
          setButtonDisable(false);
        }else{
          setButtonDisable(true);
        }
      },[ validShelfName ]
      )
 

    const formValidation =  (e) => {
      e.preventDefault();
      // console.log(e.target.id);
      // console.log(e.target.value);
      switch (e.target.id){

        case 'shelfName': 
          var shelfName = e.target.value;
          // eslint-disable-next-line 
          if (shelfName.length > 2){
            setValidFields(prevState => ({
                ...prevState,
                "shelfName": false,
                }));
            setHelperText(prevState => ({
            ...prevState,
            shelfName: "Shelf Name",
            }));
            setValidShelfName(true);
              
            }else{
              setValidFields(prevState => ({
                ...prevState,
                "shelfName": true}));

              setHelperText(prevState => ({
                ...prevState,
                shelfName: "Name needs at least three characters",
                }));
              setValidShelfName(false);
          }
          break;

        // case 'countryName':
        //   var countryName = e.target.value;
        //   // eslint-disable-next-line 
        //   if (countryName.length > 1){
        //     setValidFields(prevState => ({
        //         ...prevState,
        //         "countryName": false,
        //         }));
        //     setHelperText(prevState => ({
        //     ...prevState,
        //     countryName: "Country Name",
        //     }));
        //     setValidCountryName(true);
              
        //     }else{
        //       setValidFields(prevState => ({
        //         ...prevState,
        //         "countryName": true}));

        //       setHelperText(prevState => ({
        //         ...prevState,
        //         countryName: "Country Name needs at least two characters",
        //         }));
        //       setValidCountryName(false);
        //   }
          // break;
        // case 'itemCost':           
        //     var itemCost = e.target.value;
        //     // eslint-disable-next-line
        //     if (itemCost.length > 3){
        //         setValidFields(prevState => ({
        //             ...prevState,
        //             "itemCost": false, 
        //             }));
        //         setHelperText(prevState => ({
        //         ...prevState,
        //         itemCost: "Item Cost",
        //         }));
        //         setValidItemCost(true);
        //     }else{
        //         setValidFields(prevState => ({
        //             ...prevState,
        //             "itemCost": true}));
        //         setHelperText(prevState => ({
        //             ...prevState,
        //             itemCost: "Cost needs at least five characters",
        //             }));
        //         setValidItemCost(false);
        //     }
        //     break;
        // case 'size':
        //     var size = e.target.value;
        //     // eslint-disable-next-line
        //     if (size.length > 4){
        //         setValidFields(prevState => ({
        //             ...prevState,
        //             "size": false,
        //             }));
        //         setHelperText(prevState => ({
        //         ...prevState,
        //         size: "Size",
        //         }));
        //         setValidSize(true);
        //     }else{
        //         setValidFields(prevState => ({
        //             ...prevState,
        //             "size": true}));
        //         setHelperText(prevState => ({
        //             ...prevState,
        //             size: "State needs at least two characters",
        //             }));
        //         setValidSize(false);
        //     }
        //     break;
        // case 'weight':
        //     var weight = e.target.value;
        //     // eslint-disable-next-line
        //     if (weight.length > 0){
        //         setValidFields(prevState => ({
        //             ...prevState,
        //             "weight": false,
        //             }));
        //         setHelperText(prevState => ({
        //         ...prevState,
        //         weight: "Product Weight",
        //         }));
        //         setValidWeight(true);
        //     }else{
        //         setValidFields(prevState => ({
        //             ...prevState,
        //             "weight": true}));
        //         setHelperText(prevState => ({
        //             ...prevState,
        //             weight: "Weight needs at least five characters",
        //             }));
        //         setValidWeight(false);
        //     }
        //     break;
        // case 'manufacture':
        //     var manufacture = e.target.value;

        //     if (manufacture.length > 3){
        //         setValidFields(prevState => ({
        //             ...prevState,
        //             "manufacture": false,
        //             }));
        //         setHelperText(prevState => ({
        //         ...prevState,
        //         manufacture: "Product Manufacture",
        //         }));
        //         setValidManufacture(true);
        //     }else{
        //         setValidFields(prevState => ({
        //             ...prevState,
        //             "manufacture": true}));
        //         setHelperText(prevState => ({
        //             ...prevState,
        //             manufacture: "Manufacture needs at least six character",
        //             }));
        //         setValidManufacture(false);
        //     }
        //     break;


        default:
          break;
      }
    }


    //!SECTION
    


    //SECTION Axios Create Product
  const handleCreateShelf = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    var assignAccount =formData.get("assignAccount");
    var warehouseName =formData.get("warehouse");
    var shelfName = formData.get("shelfName");


    if (assignAccount === null || assignAccount === undefined || assignAccount === ""){
      assignAccount = userData.accountCode;
      }
    var data = {
        accountCode: assignAccount,
        warehouseName: warehouseName,
        shelfs: [shelfName]
    };

    await axios(
      {
      method: "post",
      url: `/MobileAdmin/assignwarehouseshelf/`,
      data: data,
      headers: headers
      }
      )
      .then(function (response) {
        props.handleMessageBarOpen(response.data.message, "success");
        props.toggleViewCreateShelf();
      })
      .catch(function (error) {
        props.handleMessageBarOpen(error.response.data.detail, "error");
      })


  };
  //!SECTION


  return (
    <Grid
      container
      marginTop={5}
      sx={{
        justifyContent: "center",
        alignContent: "center",
        p: 5,
        border: 1,
        borderStyle: "dotted",
        borderRadius: "5px",
      }}
    >
      {/* <Stack direction="column" alignItems="center" spacing={2}> */}
        <Typography component="h1" variant="h5">
          {title}
        </Typography>

        <Box
          component="form"
          onSubmit={handleCreateShelf}
          noValidate
          overflow="auto"
          sx={{ mt: 1 }}
        >
          {userData.userRole === 10 &&
          <TextField
            margin="normal"
            select
            required
            fullWidth
            name="assignAccount"
            label="Account"
            value={selectedAccount}
            onChange={handleAccountSelect}
            type="number"
            id="assignAccount"
            helperText="Select an Account"
          >
            {props.accountList.map((option) => (
              <MenuItem
                sx={{ whiteSpace: "normal" }}
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          }



        <TextField
            margin="normal"
            select
            required
            fullWidth
            name="warehouse"
            label="Warehouse"
            value={selectedWarehouse}
            onChange={handleWarehouseSelect}
            type="number"
            id="warehouse"
            helperText="Select an Warehouse"
          >
            {props.warehouseList.map((option) => (
              <MenuItem
                sx={{ whiteSpace: "normal" }}
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </TextField>


          <TextField
            error = {validFields.shelfName}
            helperText={helperText.shelfName}
            margin="normal"
            required
            fullWidth
            name="shelfName"
            label="ex. AB04"
            type="text"
            id="shelfName"
            onChange={(e) => formValidation(e)}
          />
         
          

          <Button
            disabled={buttonDisable}
            align="center"
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Create Shelf
          </Button>
          
          {/* <FormControlLabel
            control={<Checkbox defaultChecked onChange={handleEmailCheckbox} />}
            label="Send Mobile User Notification Email"
          /> */}
        </Box>
      {/* </Stack> */}
    </Grid>
  );
}